import FloatingNotifications from './FloatingNotifications';

export default FloatingNotifications;
